import USBButton from '@usb-shield/react-button/dist/esm'
import USBIconRemove from '@usb-shield/react-icons/dist/esm/icon-remove'
import { createCardFromList } from '@usb-ui-tools/react-billpay-layout'
import { PropTypes } from 'prop-types'
import { useMultilingualService } from '../../../../service/multilingualService'
import { isOLBOrIpadApp } from '../../../../utils/browserutils'
import getUSBExBillerLogo from '../../../../utils/extBillerLogo'
import './readytoAddBills.scss'

const ReadyToAddBills = ({
  verifiedBills,
  nonVerifiedBills,
  handleBillerRemoval
}) => {
  const { READY_TO_GO } = useMultilingualService('findbills')
  const listLength = verifiedBills.length + nonVerifiedBills.length
  const segmentListFunction = ({
    isAdditionalInfoRequired,
    merchantData: { billerName, billerLogoUrl },
    payeeAccountInfo,
    payeeId
  }) => (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row'
        }}
      >
        <div>
          <img
            name="logo"
            src={getUSBExBillerLogo(billerLogoUrl)}
            alt="biller logo"
            aria-hidden
            style={{ height: '2.5rem', width: '2.5rem' }}
          />
        </div>
        <div style={{ marginLeft: '0.5rem' }}>
          {billerName && (
            <p className="usb-tg-body-medium usb-c-gray-90">{billerName}</p>
          )}
          {payeeAccountInfo && (
            <p className="usb-tg-caption usb-c-gray-70">
              {payeeAccountInfo?.[0]?.maskedaccountNumber}
            </p>
          )}
        </div>
      </div>
      {listLength > 1 && (
        <div>
          <USBButton
            variant="text"
            id="remove-bill-btn"
            type="button"
            ariaLabel="remove bill"
            size="small"
            spacing={{ margin: 0, padding: '0 0 0 0.5rem' }}
            handleClick={() => {
              handleBillerRemoval(
                isAdditionalInfoRequired ? 'unverified' : 'verified',
                payeeId
              )
            }}
          >
            <USBIconRemove
              colorVariant="interaction"
              size={18.5}
              style={{ marginRight: 0 }}
            />
          </USBButton>
        </div>
      )}
    </div>
  )
  return (
    <>
      <div
        id="ready-to-add"
        className={
          isOLBOrIpadApp() ? 'bills__header__olb' : 'bills__header__tux'
        }
      >
        {verifiedBills?.length > 0 &&
          createCardFromList(
            verifiedBills,
            segmentListFunction,
            <div
              id={`${READY_TO_GO?.SEGMENT_HEADER}_subheader`}
              className="usb-tg-superhead usb-c-gray-80"
              style={{ marginTop: isOLBOrIpadApp() ? '12px' : '4px' }}
            >
              {READY_TO_GO?.SEGMENT_HEADER}
            </div>
          )}
        {nonVerifiedBills?.length > 0 &&
          createCardFromList(
            nonVerifiedBills,
            segmentListFunction,
            <div
              id={`${READY_TO_GO?.VERIFICATION_NEEDED}_subheader`}
              className="usb-tg-superhead usb-c-gray-80"
              style={
                (verifiedBills?.length > 0
                  ? { marginTop: isOLBOrIpadApp() ? '1.5rem' : '4px' }
                  : {},
                nonVerifiedBills?.length > 0
                  ? { marginTop: isOLBOrIpadApp() ? '12px' : '4px' }
                  : {})
              }
            >
              {READY_TO_GO?.VERIFICATION_NEEDED}
            </div>
          )}
      </div>
    </>
  )
}
ReadyToAddBills.propTypes = {
  verifiedBills: PropTypes.arrayOf(PropTypes.any).isRequired,
  nonVerifiedBills: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleBillerRemoval: PropTypes.func.isRequired
}
export default ReadyToAddBills
